import { render, staticRenderFns } from "./addAccount.vue?vue&type=template&id=2db3f4f6&scoped=true"
import script from "./addAccount.vue?vue&type=script&lang=js"
export * from "./addAccount.vue?vue&type=script&lang=js"
import style0 from "./addAccount.vue?vue&type=style&index=0&id=2db3f4f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db3f4f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db3f4f6')) {
      api.createRecord('2db3f4f6', component.options)
    } else {
      api.reload('2db3f4f6', component.options)
    }
    module.hot.accept("./addAccount.vue?vue&type=template&id=2db3f4f6&scoped=true", function () {
      api.rerender('2db3f4f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/institutionalTeamChild/addAccount.vue"
export default component.exports